export enum ENDPOINTS {
  // ___________Auth_________________
  login = "UserManagement/User/login",
  logout = "UserManagement/User/logout",
  generate_otp = "UserManagement/User/otp",

  // ____________User_________________

  me = "UserManagement/User/me",
  update_user = "UserManagement/User/update-user",
  update_profile = "UserManagement/User/update-profile",
  update_user_profile = "core/UserManagement/User",
  create_organizer = "UserManagement/User/create-organizer",
  change_user_status = "UserManagement/User/status-update",
  bank_list = "core/UserManagement/BankAccount",

  // _________________________Customer___________

  customer = "public/CustomerManagement/Customer",
  search_customer = "CustomerManagement/Customer/search-customer",

  // ___________________onboarding__________
  onboard = "UserManagement/User/onboard",

  // _______________________Attactment___________
  attachment = "/Attachment",

  // _______________________Venue__________

  venue = "core/EventManagement/Venue",

  // _______________________Event__________

  event_category = "public/EventManagement/Category",
  event = "core/EventManagement/Event",
  event_user = "core/EventManagement/EventUser",

  // __________verification___________
  kyc_verification = "UserManagement/User/create-kyc-request",
  gst_verification = "UserManagement/validate/gst",

  //___________________tickets____________
  get_tickets = "core/EventManagement/Ticket",
  get_distances = "EventManagement/distances",
  tickets_custom_form = "core/EventManagment/TicketCustomField",
  get_inclusion = "core/EventManagement/TicketInclusion",
  //______________________registration____________
  get_registration = "core/Order/Registration",

  custom_form_response = "core/Order/TicketCustomFieldResponse",
  approval = "core/Order/Order/:id",
  //___________________________Discount_________________________

  discount = "core/Discount/OrganizerDiscount",

  //__________________________Order_____________________________
  order = "core/Order/Order",
  event_refund_summary = "core/function/Payment/OrderRefund/getEventRefundSummary",

  //___________________________Affilate__________________________

  affilate = "core/Affiliate/Affiliate",

  //____________________________workspace_________________________

  access_control = "UserManagement/assign-workspace",

  //__________________________________payout________________________

  payout = "core/EventManagement/PayoutRequest",
  workspace_payout_summary = "core/function/EventManagement/PayoutRequest/getWorkspacePayoutSummary",

  checkin_registrations = "core/Order/EventCheckin",

  // ___________________________________branding_________________________
  branding = "core/EventManagement/EventBranding",

  //__________________________________________dashboard______________________
  dashboard = "core/function/Report/Dashboard/dashboard",

  workspace = "core/UserManagement/UserWorkspace",
  change_workspace = "UserManagement/User/change-workspace",

  //__________________________________________review______________________
  get_review_parameters = "core/function/EventManagement/EventReview/getAverageRating",
  get_event_review = "core/EventManagement/EventReview",
  public_event_reviews = "EventManagement/public-event-reviews",

  // change requests
  change_request = "EventManagement/change-request",

  // cities
  get_cities = "EventManagement/get-customer-cities",
}
